import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[controlValueStripSpaces]',
  standalone: false,
})
export class ControlValueStripSpacesDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input') onInputEvent(): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const original = input.value;
    const cursorPos = input.selectionStart;
    const spacesBeforeCursor = (original.slice(0, cursorPos).match(/ /g) ?? []).length;
    const stripped = original.replace(/ /g, '');

    this.control.control.setValue(stripped, { emitEvent: false });

    const newCursor = cursorPos - spacesBeforeCursor;
    input.setSelectionRange(newCursor, newCursor);
  }
}
